<template>
  <div>
    <info-mobile :info.sync="data.version" title="Version" />
    <info-mobile
      :info.sync="created_date"
      title="Created Date"
      :cols="[5, 7]"
    />
    <info-mobile
      :info.sync="last_activity"
      title="Last Activity"
      :cols="[5, 7]"
    />
    <info-mobile :info.sync="phone" title="Phone Number" />
    <info-mobile :info.sync="data.launch_mode" title="Launch Mode" />
    <info-mobile
      :info.sync="_currentRound.gpsi_car_number"
      title="Car Number"
    />
    <info-mobile :info.sync="data.status" title="Car Status" />
    <info-mobile :info.sync="data.imei" title="IMEI Number" />
  </div>
</template>
<script>
import FormatDate from '@/mixins/FormatDate';
import FormatPhone from '@/mixins/FormatPhone';
import ScreenDetailData from '@/mixins/ScreenDetailData';
import InfoMobile from '@/components/screens/InfoMobile';

export default {
  mixins: [ScreenDetailData, FormatDate, FormatPhone],
  components: {
    InfoMobile,
  },
  computed: {
    last_activity: {
      get() {
        return this.formatDate(this.data.last_activity * 1000);
      },
    },
    created_date: {
      get() {
        return this.formatDate(this.data.created_at);
      },
    },
    phone: {
      get() {
        return this.formatPhone(this.data.phone);
      },
    },
  },
};
</script>
